<template>
  <div class="page">
    <div class="center-div flex-center">
      <div class="center-box">
        <el-breadcrumb separator="|" style="border-bottom: 2px solid #e6e6e6; padding: 20px 10px">
          <el-breadcrumb-item :to="{ path: path }">首页</el-breadcrumb-item>
          <el-breadcrumb-item><a href="/">帮助中心</a></el-breadcrumb-item>
        </el-breadcrumb>
        <div class="flex-space-between">
          <div class="left borderSty" style="height: calc(100vh - 90px)">
            <div class="flex-center" style="width: 100%; margin-bottom: 20px">
              <el-input v-model="searchForm.keyWord" placeholder="请输入问题" class="inputSearch" clearable @keyup.enter.native="search">
                <template #append>
                  <el-button type="primary" @click="search">搜索</el-button>
                </template>
              </el-input>
            </div>
            <el-scrollbar class="left-nav-wrap" style="height: calc(100vh - 160px)" v-if="userManualData[0].userManuals[0] && userManualData[0].userManuals[0].id">
              <el-menu :default-active="active" :default-openeds="openeds" class="el-menu-demo" text-color="#fff" active-text-color="#3255b8" accordion>
                <el-menu-item-group>
                  <el-submenu :index="`${i}`" v-for="(item, i) in userManualData" :key="i">
                    <template #title>
                      <div class="oneLine" style="font-size: 16px; width: 90%">{{ item.categoryName }}</div>
                    </template>
                    <el-menu-item :index="`${i}-${c}`" v-for="(child, c) in item.userManuals" :key="c" @click="getIndex(i, c)">
                      <div class="oneLine" style="width: 90%">{{ child.title }}</div>
                    </el-menu-item>
                  </el-submenu>
                </el-menu-item-group>
              </el-menu>
            </el-scrollbar>
          </div>
          <div style="width: 2px; height: calc(100vh - 60px); background: #e6e6e6"></div>
          <div class="right borderSty">
            <el-scrollbar class="left-nav-wrap" style="height: calc(100vh - 90px)">
              <template v-if="userManualInfo.title">
                <div class="questTitle">{{ userManualInfo.title }}</div>
                <div class="questContent" v-html="userManualInfo.userManualDescription" />
              </template>
              <el-empty :image-size="110" v-else style="height: 430px"></el-empty>
            </el-scrollbar>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { UserManual } from "../components/HospitalDomain/UserManual";
export default {
  name: "login",
  data() {
    var userManual = new UserManual(this.TokenClient, this.Services.Healthy);
    return {
      UserManualDomain: userManual,
      userManualData: [{ userManuals: [{ id: 0 }] }],
      searchForm: {
        keyWord: "",
      },
      active: "0-0",
      userManualInfo: {
        title: "",
        userManualDescription: "",
      },
      path: "/",
      openeds: ["0"],
    };
  },
  mounted() {
    if (this.ClientId == this.YunClient || this.ClientId == this.TotalClient || this.ClientId == this.AssociationClient || this.ClientId == this.FairClient) {
      this.path = "/OutpatientIndex";
    } else {
      this.path = "/";
    }
    this.getList();
  },
  methods: {
    search() {
      this.active = "0-0";
      this.openeds = ["0"];
      this.getList();
    },
    getIndex(i, c) {
      this.openeds = [i.toString()];
      let id = this.userManualData[i].userManuals[c].id;
      this.active = `${i}-${c}`;
      this.getUserManualInfo(id);
    },
    getList() {
      var _this = this;
      _this.UserManualDomain.getUserManuals(
        _this.ClientId,
        _this.searchForm.keyWord,
        function (data) {
          _this.userManualData = data.data;
          _this.getUserManualInfo(_this.userManualData[0].userManuals[0].id);
        },
        function (err) {
          console.log(err);
          _this.userManualData = [{ userManuals: [] }];
          _this.userManualInfo = {};
        }
      );
    },
    getUserManualInfo(id) {
      var _this = this;
      _this.UserManualDomain.getUserManualsDetail(
        id,
        function (data) {
          _this.userManualInfo = data.data;
        },
        function (err) {
          console.log(err);
          _this.userManualInfo = {};
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  width: 100vw;
  height: 100vh;
  // overflow: hidden;

  .center-box {
    width: 100%;
    margin: 0 auto;
    height: 100vh;
    // box-shadow: 0px 12px 20px 0px rgba(133, 192, 205, 0.32);
    background: #fff;
  }
  .inputSearch {
    width: 90%;
    height: 45px;
    margin: 0 auto;

    ::v-deep {
      .el-input__inner {
        border-radius: 5px 0 0 5px;
        height: 45px;
      }
    }
  }
}
</style>
<style scoped lang="scss">
::v-deep .el-scrollbar__bar.is-vertical {
  opacity: 0;
}

::v-deep .left-nav-wrap {
  // background: var(--base--bg);
}
.questTitle {
  font-size: 24px;
  color: #333333;
}

.nav-subtit {
  padding-left: 20px;
  color: #303133;
  line-height: 3;
}

::v-deep .el-menu-item-group__title {
  font-family: PingFang SC;
  color: #303133 !important;
  padding-left: 5px !important;
  line-height: 30px;
  opacity: 0.8;
  padding: 0;
}

::v-deep ul.el-menu-vertical-demo .item:first-child .el-menu-item-group__title {
  padding-top: 12px;
}
.left {
  width: 20%;
}
.right {
  width: calc(80% - 2px);
  padding-left: 30px;
}
.borderSty {
  // box-shadow: 0px 12px 20px 0px rgba(133, 192, 205, 0.32);
  background: #fff;
  margin: 15px 0;
}
</style>
<style scoped>
::v-deep .el-menu {
  height: 100%;
  background: none;
  border: none;
  padding-left: 10px;
}
::v-deep .el-submenu {
  margin-bottom: 2px;
}
::v-deep .el-menu-item {
  margin-top: 2px;
}
::v-deep .el-menu-item,
::v-deep .el-submenu__title {
  height: 42px !important;
  line-height: 42px !important;
  background: none !important;
  padding-left: 20px !important;
  color: #303133 !important;
  border-radius: 5px 0 0 5px;
}

::v-deep .el-submenu__title:hover,
::v-deep .el-menu-item:hover {
  width: 100%;
  background: var(--base--Color) !important;
  transition: none;
  color: #fff !important;
}
::v-deep .el-submenu__title:hover .el-submenu__icon-arrow {
  color: #fff !important;
}
::v-deep .el-menu-item.is-active {
  background: var(--base--Color) !important;
  position: relative;
  padding-right: 0px !important;
  color: #fff !important;
}

::v-deep .el-menu-item.is-active .box {
  width: 40px;
  position: absolute;
  right: 0;
  top: -18px;
  z-index: 99;
  height: 78px !important;
  line-height: 78px !important;
}
::v-deep .el-menu-item.is-active i {
  color: #fff;
  margin-right: 10px;
}
::v-deep .el-menu-item .titleBox {
  width: 100%;
  position: relative;
  z-index: 999;
}

::v-deep .el-submenu__title i {
  color: #303133;
  margin-right: 10px;
}

::v-deep .el-menu-item i {
  color: #303133;
  margin-right: 10px;
}

::v-deep .el-scrollbar__wrap {
  overflow-x: auto;
}
</style>
